import {
  CmsBackedLandingPage,
  LANDING_PAGE_CACHE_TIME,
} from "@kunduz/feature-landing-pages";
import { serverSideTranslations } from "../common/utility/serverSideTranslations";
import { getCmsApiClientFunctions } from "@kunduz/data-access-cms-api";
import { GetStaticPropsContext } from "next";

export default CmsBackedLandingPage;

export const getStaticProps = async ({ locale }: GetStaticPropsContext) => {
  const functions = getCmsApiClientFunctions();

  const pathNames = {
    en: "en",
    "en-US": "en",
    tr: "tr",
    "tr-TR": "tr",
    "en-AE": "en",
    "en-EG": "en",
  };

  try {
    const response = await functions.getContentType(
      `/landingPages/${pathNames[locale]}/`,
    );

    if (!response) {
      return {
        notFound: true,
      };
    }

    return {
      props: {
        lang: response.language,
        meta: response,
        ...(await serverSideTranslations(response.language, [
          "kunduzcom_common",
        ])),
      },
      revalidate: LANDING_PAGE_CACHE_TIME,
    };
  } catch (error) {
    throw new Error(
      `Failed to fetch page, error detail: ${JSON.stringify(error)}`,
    );
  }
};
